export default __webpack_public_path__ + "static/media/top2.a36f2beb.png";